module.exports = __webpack_public_path__ + "img/thuydien.e5c5675b.jpg";